export default __webpack_public_path__ + "static/media/5-crocodile-BALL.0a2febcb.jpg";